// extracted by mini-css-extract-plugin
module.exports = {"headding":"crm-module--headding--129te","headdingWhite":"crm-module--headdingWhite--3xg_p","imageStyle":"crm-module--imageStyle--1Ap3a"};